import React from "react";
import PelicanLogo from "../../../public/logo.png";
import StyledStepper from "../styled/StyledStepper";

export interface RegisterStepperProps {
  activeStep: number;
}

const steps = [
  {
    title: "Votre entreprise",
    description: "Entrez les informations de votre entreprise",
  },
  {
    title: "Compte super administrateur",
    description: "Entrez les informations du compte super administrateur",
  },
  {
    title: "Coordonnées d'enlèvement",
    description: "Renseignez les informations d’enlèvement",
  },
  {
    title: "Mode de paiement",
    description: "Renseignez les informations de paiement",
  },
];

const RegisterStepper: React.FC<RegisterStepperProps> = ({ activeStep }) => {
  return (
    <div className="fixed h-full max-w-[20%] bg-gray-50">
      <div className="flex flex-col gap-20 p-8 pr-4 xl:pr-8">
        <img src={PelicanLogo} className="h-20 w-20" />
        <StyledStepper
          activeStep={activeStep}
          stepsContent={steps.map((step) => (
            <>
              <h3 className="leading-tight font-medium">{step.title}</h3>
              <p className="text-sm">{step.description}</p>
            </>
          ))}
        />
      </div>
    </div>
  );
};

export default RegisterStepper;
